<script setup lang="ts">
const ERROR_TEXT_NOT_LOADED_MAP = 'При загрузке карты произошла ошибка'
</script>

<template>
  <div>
    <span>{{ ERROR_TEXT_NOT_LOADED_MAP }}</span>
  </div>
</template>
